import * as React from "react"
import { Text as ReactNativeText } from "native-base"
import { FontStyleWrapper } from "react-native-cross-platform-text"
import { presets } from "./text.presets"
import { TextProps } from "./text.props"
import { translate } from "../../i18n"
import { Appearance, StyleProp, TextStyle } from "react-native"
import { getColor } from "native-base/src/theme/tools/colors"
import { nativeBaseTheme } from "../../theme"

/**
 * For your text displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
export function Text(props: TextProps) {
  // grab the props
  const {
    preset = "default",
    colorScheme = Appearance.getColorScheme(),
    tx, txOptions,
    text,
    children,
    style: styleOverride,
    color,
    transformText = (text) => text,
    ...rest
  } = props

  // figure out which content to use
  const i18nText = tx && translate(tx, txOptions)
  const content = transformText(text|| i18nText) || children

  const style = presets(colorScheme)[preset] || presets(colorScheme).default
  const styles: StyleProp<TextStyle>= [style, styleOverride, color ? ({ color: getColor(nativeBaseTheme, color as string) } as TextStyle) : {}]

  return (
    <FontStyleWrapper style={styles}>
      {(fontStyle) => (
        <ReactNativeText style={JSON.parse(JSON.stringify(fontStyle))} {...rest}>
          {content}
        </ReactNativeText>
      )}
    </FontStyleWrapper>
  )
}
